import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "patientAppointmentTableIsShow", true);
        Vue.set(state, "patientDisbandTableIsShow",  false);
        Vue.set(state, "patientAttendanceWrapperIsShow",  false);
        Vue.set(state, "patientAttendanceTableIsShow",  false);
        Vue.set(state, "patientAttendanceDetailsIsShow",  false);
        Vue.set(state, "patientAttendanceEKatalogusFormIsShow",  false);
        Vue.set(state, "patientEvidenceContentIsShow",  true);
        Vue.set(state, "patientEvidenceFormIsShow",  false);
        Vue.set(state, "patientEvidenceFormFinalizeIsShow",  false);
        Vue.set(state, "EHREvidenceFormIsShow",  false);
    },
    showPatientAppointmentTable (state) {
        state.patientAppointmentTableIsShow = true;
        state.patientDisbandTableIsShow = false;
        state.patientAttendanceWrapperIsShow = false;

        state.patientAttendanceTableIsShow = false;
        state.patientAttendanceDetailsIsShow = false;

        state.patientAttendanceEKatalogusFormIsShow = false;

        state.covidRapidAntigenTestFormIsShow = false;
    },

    showPatientDisbandTable (state) {
        state.patientAppointmentTableIsShow = false;
        state.patientDisbandTableIsShow = true;
        state.patientAttendanceWrapperIsShow = false;

        state.patientAttendanceTableIsShow = false;
        state.patientAttendanceDetailsIsShow = false;

        state.patientAttendanceEKatalogusFormIsShow = false;

        state.covidRapidAntigenTestFormIsShow = false;
    },

    showPatientAttendanceWrapper (state) {
        state.patientAppointmentTableIsShow = false;
        state.patientDisbandTableIsShow = false;
        state.patientAttendanceWrapperIsShow = true;

        state.patientAttendanceTableIsShow = true;
        state.patientAttendanceDetailsIsShow = false;

        state.patientAttendanceEKatalogusFormIsShow = false;

        state.covidRapidAntigenTestFormIsShow = false;
    },

    showPatientAttendanceTable (state) {
        state.patientAppointmentTableIsShow = false;
        state.patientDisbandTableIsShow = false;
        state.patientAttendanceWrapperIsShow = true;

        state.patientAttendanceTableIsShow = true;
        state.patientAttendanceDetailsIsShow = false;

        state.patientAttendanceEKatalogusFormIsShow = false;

        state.covidRapidAntigenTestFormIsShow = false;
    },

    showPatientAttendanceDetails (state) {
        state.patientAppointmentTableIsShow = false;
        state.patientDisbandTableIsShow = false;
        state.patientAttendanceWrapperIsShow = true;

        state.patientAttendanceTableIsShow = false;
        state.patientAttendanceDetailsIsShow = true;

        state.patientAttendanceEKatalogusFormIsShow = false;

        state.covidRapidAntigenTestFormIsShow = false;
    },

    showPatientAttendanceEKatalogusForm (state) {
        state.patientAppointmentTableIsShow = false;
        state.patientDisbandTableIsShow = false;
        state.patientAttendanceWrapperIsShow = true;

        state.patientAttendanceTableIsShow = false;
        state.patientAttendanceDetailsIsShow = false;

        state.patientAttendanceEKatalogusFormIsShow = true;

        state.covidRapidAntigenTestFormIsShow = false;
    },

    showCovidRapidAntigenTestForm (state) {
        state.patientAppointmentTableIsShow = false;
        state.patientDisbandTableIsShow = false;
        state.patientAttendanceWrapperIsShow = true;

        state.patientAttendanceTableIsShow = false;
        state.patientAttendanceDetailsIsShow = false;

        state.patientAttendanceEKatalogusFormIsShow = false;

        state.covidRapidAntigenTestFormIsShow = true;
    },


    showPatientEvidenceContent(state) {
        state.patientEvidenceContentIsShow = true;
        state.patientEvidenceFormIsShow = false;
        state.patientEvidenceFormFinalizeIsShow = false;
        state.EHREvidenceFormIsShow = false;
    },
    showPatientEvidenceForm(state) {
        state.patientEvidenceContentIsShow = false;
        state.patientEvidenceFormIsShow = true;
        state.patientEvidenceFormFinalizeIsShow = false;
        state.EHREvidenceFormIsShow = false;
    },
    showPatientEvidenceFormFinalize(state) {
        state.patientEvidenceContentIsShow = false;
        state.patientEvidenceFormIsShow = false;
        state.patientEvidenceFormFinalizeIsShow = true;
        state.EHREvidenceFormIsShow = false;
    },

    showEHREvidenceForm(state) {
        state.patientEvidenceContentIsShow = false;
        state.patientEvidenceFormIsShow = false;
        state.patientEvidenceFormFinalizeIsShow = false;
        state.EHREvidenceFormIsShow = true;
    },
}
